"use client";

import React from "react";
import { CheckCircle2, Info, XCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhatHseReimburses() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const facts = [{
    text: "HSE reimburses up to 8,558 euro for spine surgery.",
    included: true
  }, {
    text: "HSE reimburses up to 874 euro for pain management procedures.",
    included: true
  }, {
    text: "Medical rehabilitation reimbursement subject to HSE prior authorisation.",
    included: true
  }, {
    text: "Travel and accommodation are not reimbursable.",
    included: false
  }];
  return;
}